import { Children } from 'react';
import { useHistory } from 'react-router';

import { MDText } from 'i18n-react';

import { Button, IconText, TickCircleIcon } from '@motorway/mw-highway-code';

import { DOCUMENT_KIND_PROOF_OF_ADDRESS } from '../../../../../DocumentCapture.helpers';
import { ExampleDocuments } from '../../../../ExampleDocuments/ExampleDocuments';
import { EXAMPLE_DOCUMENTS } from '../../../../ExampleDocuments/ExampleDocuments.helpers';
import { ReactComponent as ProofOfAddress } from '../../assets/ProofOfAddress.svg';
import { IncodeFooter } from '../../components/IncodeFooter';
import { IncodeHeader } from '../../components/IncodeHeader';
import { INCODE_ANALYTICS } from '../../IncodeAnalytics';
import LocalTexts from '../Incode.texts.json';

import styles from './IncodeCaptureProofOfAddress.module.scss';

const LocalT = new MDText(LocalTexts.proofOfAddress);

const CTA = LocalT.translate('cta') as string;

const list = LocalTexts.proofOfAddress.bullets;

export const IncodeCaptureProofOfAddressTutorial = () => {
  const history = useHistory();

  return (
    <div className={styles.proofOfAddressTutorials}>

      <IncodeHeader
        instructions={LocalT.translate('instructions', {
          proofOfAddress: <span className={styles.exampleDocLink}>
            <ExampleDocuments
              {
                ...EXAMPLE_DOCUMENTS[
                  DOCUMENT_KIND_PROOF_OF_ADDRESS as keyof typeof EXAMPLE_DOCUMENTS
                ] as Record<string, unknown>
              }
              actionLink={LocalT.translate('proofOfAddress') as string}
              documentTitle={LocalT.translate('modal.title') as string}
              modalDescription={LocalT.translate('modal.description') as string}
            />
          </span>,
        })}
        title={LocalT.translate('title')}
      />
      <ul className={styles.bullets}>
        {Children.toArray(
          list?.map((bullet) => (
            <li key={bullet}>
              <IconText
                icon={TickCircleIcon}
                text={bullet}
                variant="small--regular" />
            </li>
          )),
        )}
      </ul>
      <p>
        {LocalT.translate('subtitle')}
      </p>
      <figure>
        <ProofOfAddress />
      </figure>
      <IncodeFooter>
        <Button
          fullWidth
          label={CTA}
          onClick={() => {
            INCODE_ANALYTICS.INCODE_CTA_CLICK({
              button_label: CTA,
              name: 'incode_proof_of_address_tips_clicked',
            });

            history.push(
              {
                pathname: globalThis.location.pathname,
                state: { incode: true },
              },
            );
          }}
        />
      </IncodeFooter>
    </div>
  );
};
